import { FC } from 'react';
import styled from 'styled-components';
import { defaultPalette, Palette } from 'utils/getPalette';

type Props = {
  size: number;
  palette: Palette;
} & React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>;

/* eslint-disable @typescript-eslint/no-unused-vars */
const LoaderComponent: FC<Props> = ({ className, palette, ...props }) => {
  return <div className={`loader ${className}`} {...props} />;
};

const Loader = styled(LoaderComponent)`
  --size: ${({ size }) => `${size}rem`};
  --hover-color: ${({ palette }) => palette.hover.color};
  --hover-bg: ${({ palette }) => palette.hover.bgColor};

  border: calc(var(--size) * 0.15) solid ${({ palette }) => palette.color};
  border-top: calc(var(--size) * 0.15) solid ${({ palette }) => palette.bgColor};
  border-radius: 50%;
  width: var(--size);
  height: var(--size);
  animation: spin 2s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export default Loader;

type DefaultLoaderProps = {
  size?: number;
};
export const DefaultLoader: FC<DefaultLoaderProps> = ({ size }) => {
  return <Loader size={size || 1} palette={defaultPalette} />;
};

type LoaderContainerProps = {
  width?: string;
  height?: string;
} & React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>;
const LoaderContainerComponent: FC<LoaderContainerProps> = ({
  width,
  height,
  ...props
}) => {
  return <div {...props} />;
};
export const LoaderContainer = styled(LoaderContainerComponent)`
  display: grid;
  place-items: center;
  width: ${({ width }) => width || '100%'};
  height: ${({ height }) => height || '100%'};
`;

export const LoaderCoverContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: -1rem;
  display: grid;
  place-items: center;
  height: 100%;
  background-color: white;
  z-index: 300;
`;
